// parses i_l4_[src|dst]_port_name to return port and protocol
export default function parseServiceString(service) {
  const match = (service || '').match(/(.+?)\s\((.+?)\)/);
  const [port, protocol] = match && match[2].split('/');

  return { port, protocol };
}
